import Conversation from "../model/Conversation";

export default class ConversationPhaseChangedEvent {
    /**
     * @constructor
     * @param {string} type 
     * @param {Conversation} conversation 
     * @param {string} phaseId 
     * @param {string} previousPhaseId 
     */
    constructor(type, conversation, phaseId, previousPhaseId) {
        this._type = type;

        this._conversation = conversation;
        this._phaseId = phaseId;
        this._previousPhaseId = previousPhaseId;
    }

    get type() {
        return this._type;
    }

    get conversation() {
        return this._conversation;
    }

    get phaseId() {
        return this._phaseId;
    }

    get previousPhaseId() {
        return this._previousPhaseId;
    }
}

ConversationPhaseChangedEvent.PERFORM = "ConversationPhaseChangedEvent.PERFORM";